import { FilterDropdownType } from 'components/more-filters/MoreFilters';
import { JobStatus } from 'containers/jobs/constant';

export enum ViewType {
  MEMBER = 'member',
  STATUS = 'status'
}

export enum MapFilterIds {
  CUSTOMER = 'customer',
  LOCATION = 'location',
  EXTERNAL_COMPANY = 'external_company',
  LEAD_SOURCE = 'lead_source',
  AMOUNT = 'amount',
  CREATED_BY = 'created_by',
  INVOICE_STATUS = 'invoice_status',
  ESTIMATE_STATUS = 'estimate_status',
  TAGS = 'tags',
  SERVICE_AREA = 'service_area'
}

export const MAP_FILTER_OPTIONS = [
  {
    id: MapFilterIds.CUSTOMER,
    label: 'Customer',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'ID',
    nameKey: 'name'
  },
  {
    id: MapFilterIds.SERVICE_AREA,
    label: 'Service area',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'id',
    nameKey: 'name'
  },
  {
    id: MapFilterIds.EXTERNAL_COMPANY,
    label: 'External company',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'id',
    nameKey: 'companyName'
  },
  {
    id: MapFilterIds.LEAD_SOURCE,
    label: 'Lead source',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'value',
    nameKey: 'label'
  },
  {
    id: MapFilterIds.AMOUNT,
    label: 'Amount',
    type: FilterDropdownType.AMOUNT
  },
  {
    id: MapFilterIds.CREATED_BY,
    label: 'Created by',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'merchantId',
    nameKey: 'firstName'
  },
  {
    id: MapFilterIds.INVOICE_STATUS,
    label: 'Invoice status',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'value',
    nameKey: 'label'
  },
  {
    id: MapFilterIds.ESTIMATE_STATUS,
    label: 'Estimate status',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'value',
    nameKey: 'label'
  },
  {
    id: MapFilterIds.TAGS,
    label: 'Tags',
    type: FilterDropdownType.DROPDOWN
  }
];

export enum InvoiceStatusFilter {
  PENDING = 'PENDING',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED'
}

export enum InvoiceStatusFilterTitles {
  PENDING = 'Pending',
  PAID = 'Paid',
  REFUNDED = 'Refunded'
}

export const InvoiceStatusesForFilter = Object.keys(InvoiceStatusFilter).map(key => ({
  value: InvoiceStatusFilter[key as keyof typeof InvoiceStatusFilter],
  label: InvoiceStatusFilterTitles[key as keyof typeof InvoiceStatusFilterTitles]
}));

export const FINISHED_JOB_STATUSES = [
  JobStatus.DONE,
  JobStatus.CANCELED,
  JobStatus.ARCHIVED,
  JobStatus.DONE_PENDING_APPROVAL
];

export enum SchedulePreset {
  TODAY = 'TODAY',
  NEXT_7_DAYS = 'NEXT_7_DAYS',
  NEXT_14_DAYS = 'NEXT_14_DAYS',
  THIS_WEEK = 'THIS_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  THIS_YEAR = 'THIS_YEAR',
  LAST_YEAR = 'LAST_YEAR'
}

export const SchedulePresetLabels = {
  [SchedulePreset.TODAY]: 'Today',
  [SchedulePreset.NEXT_7_DAYS]: 'Next 7 days',
  [SchedulePreset.NEXT_14_DAYS]: 'Next 14 days',
  [SchedulePreset.THIS_WEEK]: 'This week',
  [SchedulePreset.LAST_WEEK]: 'Last week',
  [SchedulePreset.THIS_MONTH]: 'This month',
  [SchedulePreset.LAST_MONTH]: 'Last month',
  [SchedulePreset.THIS_YEAR]: 'This year',
  [SchedulePreset.LAST_YEAR]: 'Last year'
};
